{
  "R": [0, 43, 103, 199, 216, 255],
  "G": [0, 0, 37, 155, 213, 255],
  "B": [0, 0, 20, 97, 201, 255],
  "A": [0, 44, 48, 54, 56, 56],
  "I": [0, 64, 128, 196, 240, 255]
}
